import React from 'react';
import ProfileForm, { PROFILE_MODES } from '../profile-form';

/**
 * Create Profile from Skillko Page
 * 
 * Thin wrapper around the unified ProfileForm component
 * configured for creating profiles from Skillko import.
 */
const CreateSkillkoProfile = () => {
  return <ProfileForm mode={PROFILE_MODES.SKILLKO} />;
};

export default CreateSkillkoProfile;
